import { memo } from "react";

interface Props {
  className?: string;
}

const BeginnerIcon = memo(({ className }: Props) => {
  return (
    <svg
      height="24"
      viewBox="0 0 18 24"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#3c424a"
        strokeWidth="2"
        transform="translate(0 -2)"
      >
        <path
          d="m2 3.12557731c.22476001 0 .44296656.07571774.61941711.21493794l5.66666667 4.47102271c.24034538.18963347.38058289.47891381.38058289.78506206v16.34069938l-7.28846353-5.7866034c-.23893483-.1896999-.37820314-.4780951-.37820314-.7831785v-14.24194019c0-.27614238.11192881-.52614238.29289322-.70710678.18096441-.18096441.43096441-.29289322.70710678-.29289322z"
          fill="#fcd100"
        />
        <path
          d="m10.0526316 3.12557731c.22476 0 .4429665.07571774.6194171.21493794l5.6666667 4.47102271c.2403453.18963347.3805828.47891381.3805828.78506206v16.34069938l-7.28846348-5.7866034c-.23893483-.1896999-.37820314-.4780951-.37820314-.7831785v-14.24194019c0-.27614238.11192881-.52614238.29289322-.70710678.1809644-.18096441.4309644-.29289322.7071068-.29289322z"
          fill="#00e4bd"
          transform="matrix(-1 0 0 1 25.77193 0)"
        />
      </g>
    </svg>
  );
});

export default BeginnerIcon;
